import { connect } from 'react-redux';
import session from 'app/services/session';
import orderModule from 'app/store/order';
import layoutModule from 'app/store/layout';
import BookingFailure from './BookingFailure.component';

const { setOrder } = orderModule.actions;
const { createToast } = layoutModule.actions;

const mapStateToProps = () => ({
  sessionOrder: session.getOrder(),
  sessionRoute: session.getRoute(),
  sessionPayment: session.getPayment()
});

const mapDispatchToProps = {
  notify: createToast,
  createOrder: setOrder
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BookingFailure);
